export default __webpack_public_path__ + "static/media/close-icon.af0d5929.svg";